// extracted by mini-css-extract-plugin
export var contact = "info-module--contact--F6fJG";
export var event = "info-module--event--I5dWH";
export var socialmedia = "info-module--socialmedia--sh9zW";